var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"donate-cta gg-branding-lead-bg font-weight-bold",attrs:{"href":_vm.donateUrl,"target":"_blank"}},[_vm._v(_vm._s(_vm.donateBtnText))])
}
var staticRenderFns = []

export { render, staticRenderFns }